import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useRole } from '@ztechapps/common.hook'
import { orderPermissions } from '@ztechapps/order.common'

export const AddNewButton = ({ onClick }) => {
  const { hasRole } = useRole({ roleName: orderPermissions.canEdit.value })
  return (
    <BusyButton
      {...{
        bsStyle: 'primary',
        icon: 'plus',
        onClick,
        text: 'Add New...',
        title: !hasRole ? 'You do not have permission to add new logistics' : 'Add new logistics.',
        disabled: !hasRole,
      }}
    />
  )
}
